import { Box, Button, Stack, styled, Typography } from '@mui/material';

import { StyledLoadingButton } from '../forms/LoadingButton';

export const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: ${(props) => props.theme.palette.background.paper};
`;

export const Content = styled(Stack)`
    width: 900px;
    max-width: 100%;
    flex-grow: 1;
    padding: 1rem 1.5rem;
`;

export const StyledTypography = styled(Typography)`
    margin-bottom: 1rem;
`;

export const StyledButton = styled(Button)`
    margin-bottom: 1rem;
`;

export const ActionButton = styled(StyledLoadingButton)`
    width: fit-content;

    margin-bottom: 1rem;
    &:last-of-type {
        margin-bottom: 0;
    }
`;
